<template>
  <div class="rental">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <template>
        <app-cells>
          <h2 class="title">Items with tag</h2>
        </app-cells>
        <app-cells>
          <app-input
            @keydown.enter.native="onScannerInputChange"
            v-model="scanner_input"
            class="input--300"
            placeholder="Enter the number and press enter"
            name="scanner"
          />
        </app-cells>
        <v-client-table
          v-if="table.items.length"
          :data="table.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{'table-default--loading': table_preloader}"
        >
          <template #h__item><div class="table-default__left">Item</div></template>
          <template #item="{ row }">
            <div class="table-default__left">
              <router-link v-if="row.item" :to="{name: 'rental-items-detail', params: { id: row.item.id }}" class="table-default__link-border">
                {{ row.item.number }} - {{ row.item.category ? `${row.item.category.name} | ` : '' }}{{ row.item.brand ? `${row.item.brand.name} | ` : '' }}{{ row.item.color ? `${row.item.color.name} | ` : '' }}{{ row.item.size ? `${row.item.size.name}` : '' }}
              </router-link>
              <span v-else>-</span>
            </div>
          </template>
          <template #price="{ row }">
            {{ row.price }}$
          </template>
          <template #controls="{ row }">
            <div class="table-default__controls">
              <button @click="onDeleteRentalItem(row.id, 'rental')" type="button"><img src="@/assets/img/delete-table-icon.svg" alt=""></button>
            </div>
          </template>
          <template #returned="{ row }">
            <label class="checkbox  checkbox--table" :class="{ 'checkbox--readonly': status === 'completed' }">
              <input
                v-model="row.returned"
                type="checkbox"
                @change="onTableCheckboxChange(row.id, { returned: row.returned })"
                name="returned"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #resupply="{ row }">
            <label class="checkbox  checkbox--table" :class="{ 'checkbox--readonly': status === 'completed' }">
              <input
                v-model="row.resupply"
                type="checkbox"
                @change="onTableCheckboxChange(row.id, { resupply: row.resupply })"
                name="resupply"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #status_after="{ row }">
            <app-select
              v-if="status !== 'completed'"
              @input="onChangeItemStatus(row.id, row.status_after)"
              v-model="row.status_after"
              :options="status_options"
              :reduce="item => item.code"
              :clearable="false"
              :searchable="false"
              :display-field="option => option.name"
              label="code"
              placeholder="Status"
              class="select--maxw"
            />
            <span v-else>{{ row.status_after?.name || '-' }}</span>
          </template>
        </v-client-table>
      </template>
      <template>
        <app-cells>
          <h2 class="title">Items without tag</h2>
        </app-cells>
        <app-cells class="cells--start-vertical">
          <app-form-group>
            <app-select
              @input="onSelectWithoutItem"
              v-model="form.item"
              :options="category_options"
              :clearable="false"
              placeholder="Item"
              class="select--200"
              :error="$v.form.item.$error"
            />
            <template #error>
              <div v-if="$v.form.item.$dirty && !$v.form.item.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group>
            <app-select
              v-model="form.brand"
              :options="brand_options"
              :reduce="item => item.id"
              :clearable="false"
              placeholder="Brand"
              class="select--200"
              :error="$v.form.brand.$error"
            />
            <template #error>
              <div v-if="$v.form.brand.$dirty && !$v.form.brand.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group>
            <app-select
              v-model="form.color"
              :reduce="item => item.id"
              :options="color_options"
              :clearable="false"
              placeholder="Color"
              class="select--200"
              :error="$v.form.color.$error"
            />
            <template #error>
              <div v-if="$v.form.color.$dirty && !$v.form.color.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group>
            <app-select
              v-model="form.size"
              :options="size_options"
              :reduce="item => item.id"
              :clearable="false"
              :readonly="!form.item"
              placeholder="Size"
              class="select--200"
              :error="$v.form.size.$error"
            />
            <template #error>
              <div v-if="$v.form.size.$dirty && !$v.form.size.required">Required field</div>
            </template>
          </app-form-group>
          <app-button @click.native="onCheckForm" ref="submit_without">Add</app-button>
        </app-cells>
        <v-client-table
          v-if="table_without.items.length"
          :data="table_without.items"
          :columns="table_without.columns"
          :options="table_without.options"
          class="table-default"
          :class="{'table-default--loading': table_without_preloader}"
        >
          <template #h__item><div class="table-default__left">Item</div></template>
          <template #item="{ row }">
            <div class="table-default__left">
            <span>
              {{ row.item ? `${row.item.name} | ` : '' }}{{ row.brand ? `${row.brand.name} | ` : '' }}{{ row.color ? `${row.color.name} | ` : '' }}{{ row.size ? `${row.size.name}` : '' }}
            </span>
            </div>
          </template>
          <template #price="{ row }">
            {{ row.price }}$
          </template>
          <template #controls="{ row }">
            <div class="table-default__controls">
              <button @click="onDeleteRentalItem(row.id, 'without')" type="button"><img src="@/assets/img/delete-table-icon.svg" alt=""></button>
            </div>
          </template>
          <template #resupply="{ row }">
            <label class="checkbox  checkbox--table" :class="{ 'checkbox--readonly': status === 'completed' }">
              <input
                v-model="row.resupply"
                type="checkbox"
                @change="onTableWithoutCheckboxChange(row.id, { resupply: row.resupply })"
                name="resupply"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #returned="{ row }">
            <label class="checkbox  checkbox--table" :class="{ 'checkbox--readonly': status === 'completed' }">
              <input
                v-model="row.returned"
                type="checkbox"
                @change="onTableWithoutCheckboxChange(row.id, { returned: row.returned })"
                name="returned"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #no_damages="{ row }">
            <label class="checkbox  checkbox--table" :class="{ 'checkbox--readonly': status === 'completed' || !row.returned }">
              <input
                v-model="row.no_damages"
                type="checkbox"
                @change="onTableWithoutCheckboxChange(row.id, { no_damages: row.no_damages })"
                name="no_damages"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #status_after="{ row }">
            <app-select
              v-if="status !== 'completed'"
              @input="onChangeWithoutItemStatus(row.id, row.status_after_rent)"
              v-model="row.status_after_rent"
              :options="status_options"
              :reduce="item => item.code"
              :clearable="false"
              :searchable="false"
              :display-field="option => option.name"
              label="code"
              placeholder="Status"
              class="select--maxw"
            />
            <span v-else>{{ row.status_after_rent?.name || '-' }}</span>
          </template>
        </v-client-table>
      </template>
    </template>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete rental
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this rental?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button v-if="current_type === 'rental'" @click.native="onDeleteItem" ref="delete">Yes</app-button>
            <app-button v-if="current_type === 'without'" @click.native="onDeleteItemWithout" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteRentalItem,
  deleteRentalItemWithout,
  getEquipmentStorageBrand,
  getEquipmentStorageCategory,
  getEquipmentStorageColor,
  getRentalItems,
  getRentalItemsStatus,
  getRentalItemsWithout,
  patchRentalItem,
  patchRentalItemWithout,
  postRentalItems,
  postRentalItemsWithout,
} from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Rental',
  props: {
    status: {
      type: String
    }
  },
  data() {
    return {
      table_preloader: false,
      table_without_preloader: false,
      is_loaded: false,
      scanner_input: null,
      table: {
        items: [],
        columns: [],
        options: {
          headings: {},
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_without: {
        items: [],
        columns: [],
        options: {
          headings: {},
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      columns_draft: ['item', 'price', 'controls'],
      headings_draft: {
        'item': 'Item',
        'price': 'Price',
        'controls': ''
      },
      columns_in_process: ['item', 'price', 'resupply', 'returned', 'status_after', 'controls'],
      headings_in_process: {
        'item': 'Item',
        'price': 'Price',
        'resupply': 'Resupply?',
        'returned': 'Returned?',
        'status_after': 'Condition',
        'controls': ''
      },
      status_options: [],
      current_id: null,
      current_type: '',
      form: {
        size: ''
      },
      category_options: [],
      brand_options: [],
      color_options: [],
      size_options: [],
    }
  },
  validations: {
    form: {
      item: { required },
      brand: { required },
      color: { required },
      size: { required },
    },
  },
  created() {
    this.fetchRentalItems()
    this.fetchRentalWithoutItems()
    getEquipmentStorageCategory().then(response => { this.category_options = response.data })
    getEquipmentStorageBrand().then(response => { this.brand_options = response.data })
    getEquipmentStorageColor().then(response => { this.color_options = response.data })
    getRentalItemsStatus().then(res => { this.status_options = res.data })
    if (!this.is_general_manager) this.columns_in_process.pop()
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  watch: {
    status(value) {
      this.switchTable(value)
    }
  },
  methods: {
    onSelectWithoutItem(e) {
      this.form.size = ''
      this.size_options = e.sizes
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit_without.preload = true
      this.table_without_preloader = true
      postRentalItemsWithout(this.$route.params.id, {...this.form, item: this.form.item.id})
        .then(response => {
          this.$emit('getRentalInfo')
          this.table_without.items = response.data
          this.table_without_preloader = false
          this.$refs.submit_without.preload = false
          this.form = {size: ''}
          this.$v.form.$reset()
        })
        .catch(() => {
          this.$refs.submit_without.preload = false
        })
    },
    fetchRentalItems() {
      getRentalItems(this.$route.params.id)
        .then(res => {
          this.is_loaded = true
          this.table.items = res.data
          this.table_preloader = false
          this.switchTable(this.status)
        })
    },
    fetchRentalWithoutItems() {
      getRentalItemsWithout(this.$route.params.id)
        .then(res => {
          this.table_without.items = res.data
          this.table_without_preloader = false
          this.switchTable(this.status)
        })
    },
    onScannerInputChange() {
      postRentalItems(this.$route.params.id, { item: this.scanner_input }).then(res => {
        this.scanner_input = null
        this.table.items = res.data
        this.$emit('getRentalInfo')
      })
    },
    onDeleteRentalItem(id, type) {
      this.$modal.show('delete-modal')
      this.current_id = id
      this.current_type = type
    },
    onDeleteItem() {
      this.$refs.delete.preload = true
      deleteRentalItem(this.$route.params.id, this.current_id)
        .finally(() => { this.$refs.delete.preload = false })
        .then(res => {
          this.table.items = res.data
          this.$notify({
            type: 'success',
            title: 'Rental item deleted',
          })
          this.$emit('getRentalInfo')
          this.$modal.hide('delete-modal')
        })
    },
    onDeleteItemWithout() {
      this.$refs.delete.preload = true
      deleteRentalItemWithout(this.$route.params.id, this.current_id)
        .finally(() => { this.$refs.delete.preload = false })
        .then(response => {
          this.table_without.items = response.data
          this.$notify({
            type: 'success',
            title: 'Rental item deleted',
          })
          this.$emit('getRentalInfo')
          this.$modal.hide('delete-modal')
        })
    },
    onTableCheckboxChange(id, data) {
      this.table_preloader = true
      patchRentalItem(this.$route.params.id, id, data)
        .then(() => {
          this.$emit('getRentalInfo')
          this.fetchRentalItems()
        })
    },
    onTableFreeCheckboxChange(id, data) {
      this.table_preloader = true
      patchRentalItem(this.$route.params.id, id, data)
        .then(() => {
          this.$emit('getRentalInfo')
          this.fetchRentalItems()
        })
    },
    onChangeItemStatus(id, value) {
      this.table_preloader = true
      const table_item = this.table.items.find(item => item.id === id)
      table_item.status_after = value
      patchRentalItem(this.$route.params.id, id, { status_after: value })
        .then(() => {
          this.$emit('getRentalInfo')
          this.fetchRentalItems()
        })
        .catch(() => {
          table_item.status_after = null
          this.table_preloader = false
        })
    },
    onTableWithoutCheckboxChange(id, data) {
      this.table_without_preloader = true
      patchRentalItemWithout(this.$route.params.id, id, data)
        .then(response => {
          this.$emit('getRentalInfo')
          this.table_without.items = response.data
          this.table_without_preloader = false
        })
    },
    onChangeWithoutItemStatus(id, value) {
      this.table_without_preloader = true
      const table_item = this.table_without.items.find(item => item.id === id)
      table_item.status_after_rent = value
      patchRentalItemWithout(this.$route.params.id, id, { status_after_rent: value })
        .then(response => {
          this.$emit('getRentalInfo')
          this.table_without.items = response.data
          this.table_without_preloader = false
        })
        .catch(() => {
          table_item.status_after_rent = null
          this.table_without_preloader = false
        })
    },
    switchTable(status) {
      if (status === 'draft') {
        this.table.columns = this.columns_draft
        this.table.options.headings = this.headings_draft
        this.table_without.columns = this.columns_draft
        this.table_without.options.headings = this.headings_draft
      } else if (status === 'in_process' || status === 'completed') {
        this.table.columns = this.columns_in_process
        this.table.options.headings = this.headings_in_process
        this.table_without.columns = this.columns_in_process
        this.table_without.options.headings = this.headings_in_process
      }
    },
  }
}
</script>
<style lang="sass" scoped>
.rental
  position: relative
  min-height: 100px
</style>
